import React, { StrictMode } from 'react';
import PropTypes from 'prop-types';

import { ContextProvider as TeamsContextProvider } from 'components/Managers/Teams/Context';
import { ContextProvider as TemplatesContextProvider } from 'components/Managers/Templates/Context';
import { ContextProvider as UsersContextProvider } from 'components/Users/Context';
import { ContextProvider } from './Context';
import Main from './Main';

export default function Index({ enterpriseId, finchOptions }) {
  return (
    <StrictMode>
      <UsersContextProvider>
        <ContextProvider enterpriseId={enterpriseId} finchOptions={finchOptions}>
          <TeamsContextProvider>
            <TemplatesContextProvider enterpriseId={enterpriseId}>
              <Main />
            </TemplatesContextProvider>
          </TeamsContextProvider>
        </ContextProvider>
      </UsersContextProvider>
    </StrictMode>
  );
}

Index.propTypes = {
  enterpriseId: PropTypes.number.isRequired,
  finchOptions: PropTypes.object,
};

Index.defaultProps = {
  finchOptions: {},
};
